import React, { useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { ParseHtml } from "../../../utils/parseHtml";
import { FormLoader } from "../../../utils/Loader";
import evalStyle from "../../../assets/css/modules/evalhistory.module.css";
const groupBy = (arr, key) =>
  arr.reduce((acc, item) => {
    const k = item[key];
    acc[k] = acc[k] || [];
    acc[k].push(item);
    return acc;
  }, {});

const EvaluationScreen = ({
  isFetching,
  toggleModal,
  activeOrganizationInfo,
  activityHistoryAllInfo,
}) => {
  /* ---------- loading guard ---------- */
  if (isFetching) {
    return (
      <div className="text-center">
        <FormLoader width={800} />
      </div>
    );
  }

  if (!activityHistoryAllInfo) {
    return <div className="p-3 text-center">No data available</div>;
  }
  const {
    evaluationESIISummaryDetails = {},
    evaluationFormESIIList = [],
    formid,
  } = activityHistoryAllInfo;
  if (!evaluationESIISummaryDetails) {
    return (
      <div className="p-3 text-center">No evaluation summary available</div>
    );
  }
  const {
    dataLabels = [],
    questionAnswers = [],
    summaryNotes = [],
    qaUrlNotes = [],
    formDetails = [],
  } = evaluationESIISummaryDetails || {};

  const currentForm = evaluationFormESIIList?.find((f) => f.formid === formid);

  const isAverage = currentForm?.formscoringtype?.toLowerCase() === "average";

  const evalIdLabels = dataLabels.filter(
    (x) => x.labelType === "Evaluation ID Display",
  );

  const positiveSortLabels = dataLabels
    .filter((x) => x.sortOrder > 0 && x.labelType !== "Evaluation ID Display")
    .sort((a, b) => a.sortOrder - b.sortOrder);

  const negativeSortLabels = dataLabels
    .filter((x) => x.sortOrder < 0 && x.labelType !== "Evaluation ID Display")
    .sort((a, b) => b.sortOrder - a.sortOrder);

  const sortedAdditinalnotes = [...(summaryNotes || [])].sort(
    (a, b) => a.sortorder - b.sortorder,
  );

  const isM1review =
    evaluationFormESIIList?.find((x) => x.formid === formid)?.M1review === true;
  const isM1ReviewFeedBackNotesDateTime = formDetails?.some(
    (x) => x.m1ReviewFeedBackNotesDateTime !== null,
  );
  let showastrick = false;
  let isEnableAcknowledgementCheckbox = false;
  let isEnableAcknowledgementCheckbox1 = false;
  let isEnableAcknowledgementIsRequired = false;
  if (isM1ReviewFeedBackNotesDateTime) {
    isEnableAcknowledgementIsRequired =
      evaluationFormESIIList?.find((x) => x.formid === formid)
        ?.enableAcknowledgementIsRequired === true;

    showastrick =
      evaluationFormESIIList !== null &&
      evaluationFormESIIList?.some((x) => x.formid === formid) &&
      evaluationFormESIIList?.find((x) => x.formid === formid)
        ?.enableAcknowledgementIsRequired === true;

    isEnableAcknowledgementCheckbox =
      evaluationFormESIIList?.some((x) => x.formid === formid) &&
      evaluationFormESIIList?.find((x) => x.formid === formid)
        ?.enableAcknowledgementCheckbox === true &&
      formDetails?.some((x) => x.ack === null);

    isEnableAcknowledgementCheckbox1 =
      evaluationFormESIIList?.some((x) => x.formid === formid) &&
      evaluationFormESIIList?.find((x) => x.formid === formid)
        ?.enableAcknowledgementCheckbox === true &&
      formDetails?.some((x) => x.ack !== null);
  }

  const closeBtn = (
    <div className="links_right w-45">
      <button className="modal_close" onClick={toggleModal} type="button">
        <img title="Attached File" src="images/close.svg" />
      </button>
    </div>
  );
  return (
    <div id="eval_history_details">
      <ModalHeader
        toggle={toggleModal}
        close={closeBtn}
        className="custom-modal metric_header"
      >
        <div className="d-flex flex-start align-center">
          <div className="title">QA Form History</div>
        </div>
      </ModalHeader>
      <ModalBody id="" style={{ maxHeight: "80vh", overflowY: "auto" }}>
        <div className="row">
          {[...evalIdLabels, ...positiveSortLabels, ...negativeSortLabels]?.map(
            (dataLable, index) => (
              <div className="col-md-3" key={index}>
                <div className="form-group">
                  <label>{dataLable.labelName}</label>
                  <div
                    key={dataLable.labelName + index}
                    className="form-control"
                    contentEditable="false"
                    style={
                      dataLable.labelType?.toLowerCase() == "richtext"
                        ? {
                            maxHeight: "100%",
                            whiteSpace: "normal",
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                            wordBreak: "break-word",
                          }
                        : {}
                    }
                  >
                    {dataLable.labelType == "PrimaryProgram" ||
                    dataLable.labelType == "EvaluatedTo"
                      ? ParseHtml(dataLable.labelNameValue)
                      : ParseHtml(dataLable.labelValue)}
                  </div>
                </div>
              </div>
            ),
          )}
        </div>
        <div className="row">
          <div className="col-md-12">
            {questionAnswers?.map((qaItem, index) => {
              const sortedquestions = [...(qaItem.questions || [])].sort(
                (a, b) => a.sortoder - b.sortoder,
              );

              return (
                <div
                  className={evalStyle.categories_questionsandans}
                  key={`qa-${index}`}
                >
                  <div className="card">
                    <div className={evalStyle["card-header"]}>
                      <h3>{qaItem.category}</h3>
                    </div>
                    {sortedquestions?.map((question, qIndex) => {
                      return (
                        <div className="card-body" key={`q-${qIndex}`}>
                          <div className={evalStyle.question_block}>
                            <div className={evalStyle.questionn}>
                              {question.ishtml
                                ? ParseHtml(question.questionname)
                                : question.questionname}
                            </div>
                            <div
                              className={`${evalStyle.answerr} ${evalStyle.defaultt_color} `}
                            >
                              {question.answer}
                            </div>
                            <div className="d-flex space-between align-center">
                              <div
                                className={`${evalStyle["w-100"]} ${evalStyle["mr-5"]}`}
                              >
                                <textarea
                                  className="form-control"
                                  rows="3"
                                  cols="10"
                                  readOnly
                                >
                                  {/* bool showNotes = false;


                                  if (loggedInUserEmail.StartsWith("amplifai.", StringComparison.OrdinalIgnoreCase))
                                  {
                                    showNotes = true;
}
                                  else if (!string.IsNullOrEmpty(roleConfigValue))
                                  {
                                    showNotes = true; */}

                                  {/* {question.notes}  to hide the block when logged in with that particular user*/}
                                </textarea>
                              </div>
                              <div className={evalStyle["points"]}>
                                {isAverage ? (
                                  <span>
                                    {Number(question.score).toFixed(2)}
                                  </span>
                                ) : (
                                  <>
                                    <span>
                                      {Number(question.score).toFixed(2)}
                                    </span>
                                    <span> out of </span>
                                    <span>
                                      {Number(question.maxpoints).toFixed(2)}
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="row">
          <div className={evalStyle.categories_questionsandans}>
            <div className="col-md-12 px-0">
              <div className="card">
                <div className={evalStyle["card-header"]}>
                  <h3>Summary Notes</h3>
                </div>
                {sortedAdditinalnotes?.map((note, noteIndex) => (
                  <div className="card-body" key={`note-${noteIndex}`}>
                    <label>{note.notesLabel}</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      cols="10"
                      readOnly
                    >
                      {note.notesAnswer}
                    </textarea>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className={evalStyle.categories_questionsandans}>
            <div className="col-md-12 px-0">
              <div className="card">
                <div className={evalStyle["card-header"]}>
                  <h3>QA Url Notes</h3>
                </div>

                {qaUrlNotes.map((item, i) => (
                  <div className="card-body" key={i}>
                    <label>{item.qaUrlLabel}</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      cols="10"
                      readOnly
                    >
                      {item.qaUrlLabelValue}
                    </textarea>
                    {/* <a
                        className="form-control evalsummarypopupurllink"
                        href={item.qaUrlLabelValue}
                      >
                        {item.qaUrlLabelValue}
                      </a> */}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row" id="AckEvalBlockShow">
          <div className="col-md-12">
            <div className="form-group">
              <label>Acknowledgement Notes</label>
              <textarea
                spellCheck="true"
                rows="5"
                id="acknowledgement"
                placeholder="Please add your comments regarding this interaction"
                className={`form-control child acknowledgement `}
              ></textarea>
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-check"></div>
          </div>
        </div> */}
      </ModalBody>
    </div>
  );
};

export default EvaluationScreen;
